var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-4 ma-0",attrs:{"outlined":""}},[(_vm.alerts.store.status)?_c('alert-component',{attrs:{"alert":_vm.alerts.store}}):_vm._e(),_c('div',{staticClass:"text-h6 mb-4"},[_vm._v("Proposta - Código "+_vm._s(_vm.item.codigo)+" ")]),_c('main-show',{attrs:{"object":_vm.item}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }